module.exports = __webpack_public_path__ + "static/media/book1.d06b1c59.svg";